<template>
  <main>
    <section class="whiteBox">
      <div class="content">
        <h1>{{$t('modifyPassword.title')}}</h1>
        <br>
        <label class="accentuate">{{$t('modifyPassword.oldPassword')}}</label>
        <span
          class="errorSentence"
          v-if="!oldPasswordFormat && isSubmitted"
        >{{$t('error.wrongPassword')}}</span>
        <span
          class="errorSentence"
          v-if="displayWrongPassword && isSubmitted"
        >{{$t('error.wrongPasswordEntered')}}</span>

        <div class="row alignCenter">
          <div class="demiRowIn">
            <input
              :type="inputClass"
              v-model="oldPassword"
            >
            <span
              @mousedown="displayPassword"
              @mouseup="hidePassword"
              @mouseleave="hidePassword"
              :class="toggleClass"
            ></span>
          </div>
          <div class="demiRow">
            <p class="tips">{{$t('modifyPassword.oldPassword')}}</p>
          </div>
        </div>
        <br>
        <br>
        <label class="accentuate">{{$t('modifyPassword.newPassword')}}</label>
        <p
          class="errorSentence"
          v-if="!newPasswordFormat && isSubmitted"
        >{{$t('error.wrongPassword')}}</p>

        <div class="row alignCenter">
          <div class="demiRowIn ">
            <input
              :type="inputClass"
              v-model="newPassword"
            >
            <span
              @mousedown="displayPassword"
              @mouseup="hidePassword"
              @mouseleave="hidePassword"
              :class="toggleClass"
            ></span>
          </div>
          <div class="demiRow">
            <p class="tips">{{$t('modifyPassword.newPassword')}}</p>
          </div>
        </div>
        <br>
        <button @click="modifyPassword()">{{$t('button.modifyPassword')}}</button>
        <a @click="goBack">{{$t('button.cancel')}}</a>
      </div>
    </section>

    <PasswordModifiedAlert
      v-if="displayPasswordChange"
      @close="goBack"
    >
    </PasswordModifiedAlert>

  </main>
</template>

<script>
import passwordManagement from "@/mixins/passwordManagement";
import PasswordModifiedAlert from "@/components/users/PasswordModifiedAlert";
import Users from "@/services/Users";
import cookie from "vue-cookie";
export default {
  mixins: [passwordManagement],
  components: { PasswordModifiedAlert },
  data() {
    return {
      displayWrongPassword: false,
      displayPasswordChange: false,
      isSubmitted: false,
      oldPassword: "",
      newPassword: ""
    };
  },
  computed: {
    oldPasswordFormat: function() {
      return this.checkPassword(this.oldPassword);
    },
    newPasswordFormat: function() {
      return this.checkPassword(this.newPassword);
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "allCampaigns",
        params: { campaignType: "active" }
      });
    },
    modifyPassword() {
      this.isSubmitted = true;
      if (this.oldPasswordFormat && this.newPasswordFormat) {
        if (cookie.get("mgc-u-id") != "" && cookie.get("mgc-u-id") != null)
          Users.updatePassword(cookie.get("mgc-u-id"), {
            password: this.oldPassword,
            "new-password": this.newPassword
          })
            .then(res => {
              if (res.status == 204) this.displayPasswordChange = true;
            })
            .catch(err => {
              //TO_DO change server response
              if (err.response.status == 403) this.displayWrongPassword = true;
            });
      }
    }
  }
};
</script>

